import React, { useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons';
import MenuWrapper, { Menu, Divider } from './style';
import { logoSmall, logoVertical } from '../../assets';
import { mainMenu, menuAdmin, menuTeam, menuPersonal } from './listOfMenu';
import { AuthService } from '../../services';
import URL from '../../configs/baseUrl';

const Index = () => {
  const member = 'member';
  const history = useHistory();
  const { pathname } = history.location;
  const userData = AuthService.getUserData();

  const userRole = userData?.roles?.filter((role) => {
    return role.scope === 1;
  });
  const userRoleSlug = userRole?.[0]?.slug;
  const userRoleName = userRole?.[0]?.name;
  let teamName = userData?.team?.name;
  const teamNameLength = teamName?.length || 0;
  if (teamNameLength > 17) {
    teamName = `${teamName.substring(0, 17)}...`;
  }
  const isDefaultTeam = userData?.team?.id === userData?.default_team_id;
  const isMember = member === userRoleSlug;

  const [disabledOnHover, setIsDisabledOnHover] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);

  const onMouseLeaveEnter = (value) => {
    if (!disabledOnHover) {
      setIsCollapsed(value);
    }
  };

  const onClickButtonCollapsed = () => {
    setIsDisabledOnHover(true);
    setIsCollapsed(!isCollapsed);
  };

  const filteredAdminMenu = () => {
    return menuAdmin.filter((item) => {
      return item.isShow;
    });
  };

  const filteredTeamMenu = () => {
    return menuTeam.filter((item) => {
      return item.isShow;
    });
  };

  const filteredMainMenu = () => {
    return mainMenu.filter((item) => {
      return item.isShow;
    });
  };

  // eslint-disable-next-line no-unused-vars
  const isAvailableTeamMenu = filteredTeamMenu().length !== 0;

  const activeMenu = (itemPath) => {
    if (itemPath === URL.DASHBOARD && pathname === URL.DASHBOARD) {
      return 'ant-menu-item-selected active';
    }
    if (itemPath !== URL.DASHBOARD) {
      if (pathname.includes(itemPath)) {
        return 'ant-menu-item-selected  active';
      }
    }
    return '';
  };

  const availableMenu = (isAvailable) => {
    if (!isAvailable) {
      return 'component_sidebar_menu-unavailable';
    }
    return '';
  };

  return (
    <MenuWrapper>
      <Menu
        mode="inline"
        inlineCollapsed={isCollapsed}
        onMouseEnter={() => {
          onMouseLeaveEnter(false);
        }}
        onMouseLeave={() => {
          onMouseLeaveEnter(true);
        }}
        isCollapsed={isCollapsed}
      >
        <div className="component_sideBar_logo_wrapper">
          <img
            src={isCollapsed ? logoSmall : logoVertical}
            alt="Alphaveritas Logo"
            className="component_sideBar_logo"
          />
        </div>
        {
          /* menu  Admin */
          !isMember && (
            <>
              <div className="font-caption_medium black2  component_sidebar_title component_sideBar_padding">
                {isCollapsed ? ' ' : userRoleName}
              </div>
              {filteredAdminMenu().map((item) => {
                return (
                  <Menu.Item
                    key={item.label}
                    icon={item.icon}
                    className={`${activeMenu(item.to)} ${availableMenu(
                      item.isAvailable
                    )}`}
                  >
                    <NavLink to={item.isAvailable ? item.to : ''}>
                      {item.label}
                    </NavLink>
                  </Menu.Item>
                );
              })}
              {filteredTeamMenu()?.length > 0 && <Divider />}
            </>
          )
        }
        {
          /* menu  Team */
          !isDefaultTeam && (
            // !isDefaultTeam && isAvailableTeamMenu && (
            <>
              {isMember ? (
                <div className="font-caption_medium black2 component_sideBar_padding component_sidebar_title">
                  {isCollapsed ? ' ' : `Team ${teamName}`}
                </div>
              ) : (
                !isCollapsed && (
                  <div className="font-caption_medium black2 component_sideBar_padding component_sidebar_title">
                    {`Team ${teamName}`}
                  </div>
                )
              )}
              {filteredTeamMenu().map((item) => {
                return (
                  <Menu.Item
                    key={item.label}
                    icon={item.icon}
                    className={`${activeMenu(item.to)} ${availableMenu(
                      item.isAvailable
                    )}`}
                  >
                    <NavLink to={item.isAvailable ? item.to : ''}>
                      {item.label}
                    </NavLink>
                  </Menu.Item>
                );
              })}
              <Divider />
            </>
          )
        }
        {isDefaultTeam && isMember && (
          <div className="component_sidebar_dummy-space" />
        )}
        {
          // main menu user
          filteredMainMenu().map((item) => {
            return (
              <Menu.Item
                key={item.label}
                icon={item.icon}
                className={`${activeMenu(item.to)} ${
                  mainMenu[mainMenu.length - 1].label === item.label &&
                  !isDefaultTeam
                    ? 'component_sidebar_last_item'
                    : ''
                } ${availableMenu(item.isAvailable)}`}
                id={item?.className}
              >
                <NavLink to={item.isAvailable ? item.to : ''}>
                  {item.label}
                </NavLink>
              </Menu.Item>
            );
          })
        }
        {
          /* personal Team */
          isDefaultTeam && (
            <>
              <Divider />
              {menuPersonal.map((item) => {
                return (
                  <Menu.Item
                    key={item.label}
                    icon={item.icon}
                    className={`${activeMenu(item.to)} ${
                      menuPersonal[menuPersonal.length - 1].label === item.label
                        ? 'component_sidebar_last_item'
                        : ''
                    } ${availableMenu(item.isAvailable)}`}
                  >
                    <NavLink to={item.isAvailable ? item.to : ''}>
                      {item.label}
                    </NavLink>
                  </Menu.Item>
                );
              })}
            </>
          )
        }
        <div
          className={`component_sideBar_collapsed ${
            !isCollapsed ? 'opened' : ''
          }`}
        >
          <div>
            <Divider />
            <Menu.Item
              key="collapse"
              icon={
                isCollapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />
              }
              onClick={() => {
                onClickButtonCollapsed();
              }}
              className="component_sideBar_collapseItem"
            >
              <div>{!isCollapsed && 'Collapse Sidebar'}</div>
            </Menu.Item>
          </div>
        </div>
      </Menu>
    </MenuWrapper>
  );
};

export default Index;
